export default __webpack_public_path__ + "static/media/01.54e36096.jpg";